import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useMainContext } from "../../../Context";
import { post } from "../../../Server";

const useVerifyCode = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const { dispatch } = useMainContext();
  const {
    state: { mobile },
  } = useLocation();
  const navigate = useNavigate();
  const send = async () => {
    setLoading(true);
    const { data, status } = await post(
      "/validation",
      {
        mobile,
        ...form,
        app: true,
      },
      true
    );
    if (+status === 200 && data?.user) {
      dispatch("user", data);
      navigate("/");
      setLoading(false);
    }
  };
  return {
    loading,
    form,
    send,
    setForm,
  };
};

export default useVerifyCode;
